import styled from 'styled-components';

import type { Size as ThemeSize } from '../../../style/types/theme';
import { Size } from './types';

const getSize = (size: Size, themeSize: ThemeSize) => {
  switch (size) {
    case Size.S:
      return themeSize.units(3);
    case Size.M:
      return themeSize.units(4);
    default:
      return themeSize.units(4);
  }
};

interface UserAvatarWrapperProps {
  $borderColor: string;
  $size: Size;
  $isActive: boolean;
}

export const UserAvatarWrapper = styled.div<UserAvatarWrapperProps>(
  ({ $isActive, $borderColor, $size, theme: { size } }) => ({
    display: 'inline-flex',
    justifyContent: 'center',
    alignItems: 'center',
    borderRadius: '50%',
    border: `2px solid ${$borderColor}`,
    boxSizing: 'border-box' as const,
    overflow: 'hidden',
    width: getSize($size, size),
    height: getSize($size, size),
    transform: $isActive ? 'translateY(-2px)' : 'translateY(0)',
    transition: 'transform .1s cubic-bezier(.4, 0, .4, 1)',
  }),
);

export interface ActiveLineProps {
  $color: string;
  $show: boolean;
}

export const ActiveLine = styled.div<ActiveLineProps>(
  ({ $show, $color, theme: { size, transition } }) => ({
    width: '100%',
    height: size.units(0.25),
    backgroundColor: $color,
    transform: $show ? 'scaleX(1)' : 'scaleX(0)',
    transition: transition.standard('transform'),
  }),
);

export interface WrapperProps {
  $isActive: boolean;
}

export const Wrapper = styled.div<WrapperProps>(
  ({ $isActive, onClick, theme: { size } }) => ({
    cursor: onClick ? 'pointer' : 'default',
    display: 'inline-flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    position: 'relative',

    [ActiveLine]: {
      position: 'absolute',
      bottom: size.units(-1),
    },

    ...(onClick && {
      '&:active': {
        [UserAvatarWrapper]: {
          transform: `translateY(${$isActive ? '-2px' : '0'}) scale(.9)`,
          transition: 'transform .1s cubic-bezier(.4, 0, .4, 1)',
        },
      },
    }),
  }),
);
